import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PanelStore } from './panel-store.service';

/** Dane klienta przed wejściem do powłoki; błąd nie blokuje nawigacji (ekrany pokazują stan błędu). */
export const panelResolver: ResolveFn<boolean> = () => inject(PanelStore).load();
